import { useTranslation } from "react-i18next";
import { Button, Container } from "reactstrap";

function FixedSave({ onSave, loading, disabled }) {
  const { t } = useTranslation();

  return(
    <div className="position-fixed py-2 bg-white w-100 left-0 bottom-0 shadow-lg">
      <Container fluid>
        <Button color="primary" size="sm" className="me-2" onClick={onSave} disabled={disabled}>
          {loading ? t('common.saving') : t('common.save')}
        </Button>
        <Button color="dark" outline size="sm" onClick={() => window.history.back()}>
          { t('common.cancel') }
        </Button>
      </Container>
    </div>
  );
}

export default FixedSave;